import styles from "./Select.module.css";

const Select = ({
	value,
	onChange,
	options = [],
	placeholder = "Select an option",
	disabled = false,
	className,
	...props
}) => {
	return (
		<select
			className={`${styles.select} ${className || ""}`}
			value={value}
			onChange={onChange}
			disabled={disabled}
			{...props}
		>
			<option value="">{placeholder}</option>
			{options.map((option) => (
				<option key={option.value} value={option.value}>
					{option.label}
				</option>
			))}
		</select>
	);
};

export default Select;
